import React, { useState, useEffect, Fragment, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { SkeletonDahsboard } from "../../../components/skeleton/skeletonDash";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import { returnToSignin } from "../../../utils/returnToSign";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";
import { useCredit } from "../../../context/creditContext";
import { APIClient } from "../../../helpers/api_helper";
import { GET_SETTING_BY_NAME } from "../../../helpers/url_helper";
import { RewardsViewContext } from "../../../context/Disclosures/rewards/rewardsContext";

const apiClient = new APIClient();

export function LevelCustomerPage() {
    let navigate = useNavigate();
    const { updateRewardsView, rewardsViewData } = useContext(RewardsViewContext);
    const { disclosures, creditInfo, due } = useCredit();
    const [isLoading, setIsLoading] = useState(true);
    const [levelsConfig, setLevelsConfig] = useState({});

    const levels = [
        {
            name: "Nivel 1: 0 a 299 puntos",
            rewards: ["1. Acceso a cupo de crédito"],
        },
        {
            name: "Nivel 2: 300 a 699 puntos",
            rewards: [
                "1. Aumentar cupo hasta 5% o recibir 2% de descuento en firma electrónica",
                "2. Nuevo avatar",
            ],
        },
        {
            name: "Nivel 3: 700 a 1499 puntos",
            rewards: [
                "1. Aumentar cupo hasta 5% o recibir 3% de descuento en firma electrónica",
                "2. Nuevo avatar",
            ],
        },
        {
            name: "Nivel 4: 1500 a 2999 puntos",
            rewards: [
                "1. Aumentar cupo hasta 10% o recibir 4% de descuento en firma electrónica",
                "2. Nuevo avatar",
            ],
        },
        {
            name: "Nivel 5: 3000 a 6999 puntos",
            rewards: [
                "1. Aumentar cupo hasta 15% o recibir 6% de descuento en firma electrónica",
                "2. Nuevo avatar",
            ],
        },
        {
            name: "Nivel 6: +7000 puntos",
            rewards: [
                "1. Aumentar cupo hasta 30% o recibir 9% de descuento en firma electrónica",
                "2. Nuevo avatar",
            ],
        },
    ];

    const youActions = [
        { description: "Gestionar un crédito exitosamente = 100 puntos" },
        { description: "Pagar en la fecha límite o antes = 200 puntos" },
        { description: "Pagar con entre 1 a 5 días en mora = 100 puntos" },
        { description: "Pagar con entre 5 días y 20 días en mora = 0 puntos" },
        { description: "Pagar con entre 20 días y 30 días en mora = -200 puntos" },
        { description: "Pagar con más 30 días en mora = Pierdes todos tus puntos" },
    ];

    const otherActions = [
        {
            description: "Que tu referido firme un crédito exitosamente = 100 puntos",
        },
        {
            description:
                "Que tu referido pague en la fecha límite o antes = 200 puntos",
        },
        {
            description:
                "Que tu referido pague con menos de 6 días en mora = 100 puntos",
        },
        {
            description:
                "Que tu referido pague con más de 5 días en mora = -100 puntos",
        },
    ];

    const handleGetLevelsConfig = async () => {
        try {
            let { data } = await apiClient.get(GET_SETTING_BY_NAME, { name: 'levels-config' });
            let value = data?.data?.value;
            let levels = value[0]?.levels;
            let youActions = value[0]?.youActions;
            let otherActions = value[0]?.otherActions;
            setLevelsConfig({ levels, youActions, otherActions });
        } catch (error) {
            console.log(error);
        }
    };

    const handleOpenDisclosure = () => {
        handleOpenDisclosureMyRewards();
    };

    const handleOpenDisclosureMyRewards = () => {
        updateRewardsView({ ...rewardsViewData, openDisclosure: true, openDisclosureMyRewards: true });
    };


    useEffect(() => {
        const validSessionAndTokenJwt = async () => {
            try {
                let isValidToken = await validateSessionAndJwtToken();
                return isValidToken;
            } catch (error) {
                return false;
            }
        };

        validSessionAndTokenJwt()
            .then(async (isValidToken) => {
                if (isValidToken) {
                    handleGetLevelsConfig();
                    setIsLoading(false);
                } else {
                    returnToSignin(navigate);
                }
            })
            .catch((e) => {
                console.log(e);
                returnToSignin(navigate);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return (
            <Fragment>
                <DashboardMyCredit
                    name={"Cargando"}
                    balance={""}
                    current={"4"}
                    title={"Nivel de cliente"}
                    main={
                        <>
                            <div className="mb-32 md:mb-0">
                                <div className="mx-6 lg:mx-0">
                                    El nivel de cliente determina tu acceso a beneficios como
                                    aumento de cupo, aumento de plazo y descuentos sobre tarifas e
                                    intereses, además de desbloquear mejoras a tu avatar
                                </div>
                                {/* Cards Profile */}
                                <div className="md:h-120 mt-4 lg:mt-10 md:mx-6 lg:mx-0 bg-white rounded-3xl p-4 overflow-y-auto">
                                    <div className="">
                                        <SkeletonDahsboard height={20} width={330} />
                                    </div>
                                    <div className="pt-2">
                                        <div className="py-2">
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={80} />
                                            </div>
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={140} />
                                            </div>
                                        </div>
                                        <div className="py-2">
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={120} />
                                            </div>
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={100} />
                                            </div>
                                        </div>
                                        <div className="py-2">
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={140} />
                                            </div>
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={140} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pt-2">
                                        <div className="py-2">
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={80} />
                                            </div>
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={140} />
                                            </div>
                                        </div>
                                        <div className="py-2">
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={120} />
                                            </div>
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={100} />
                                            </div>
                                        </div>
                                        <div className="py-2">
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={140} />
                                            </div>
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={140} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pt-2">
                                        <div className="py-2">
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={80} />
                                            </div>
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={140} />
                                            </div>
                                        </div>
                                        <div className="py-2">
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={120} />
                                            </div>
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={100} />
                                            </div>
                                        </div>
                                        <div className="py-2">
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={140} />
                                            </div>
                                            <div className="">
                                                <SkeletonDahsboard height={15} width={140} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" text-grayP">
                                        <SkeletonDahsboard height={15} width={60} />
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                />
            </Fragment>
        );
    }

    return (
        <DashboardMyCredit
            name={localStorage.getItem("firstname")}
            current={"4"}
            title={"Nivel de cliente"}
            disclosures={disclosures}
            creditInfo={creditInfo}
            due={due}
            main={
                <>
                    <div className="mb-32 md:mb-0">
                        <div className="mx-6 lg:mx-0">
                            El nivel de cliente determina tu acceso a beneficios como aumento
                            de cupo, aumento de plazo y descuentos sobre tarifas e intereses,
                            además de desbloquear mejoras a tu avatar
                        </div>
                        <div className="md:h-120 mt-4 lg:mt-10 md:mx-6 lg:mx-0 bg-white rounded-3xl p-4 overflow-y-auto">
                            <div className="text-grayP">
                                Estos son los puntos requeridos para cada nivel
                            </div>
                            <div className="">
                                <div className="pt-4">
                                    {(levelsConfig?.levels ?? levels).map((level, index) => (
                                        <Fragment key={"fragment-level" + index}>
                                            <div className="pb-4" key={"div-level-name" + index}>
                                                <div
                                                    className="font-bold"
                                                    key={"div-level-name-child" + index}
                                                >
                                                    {level.name}
                                                </div>
                                                <div className="text-sm" key={"level-rewards" + index}>
                                                    <div
                                                        className="font-bold text-grayP"
                                                        key={"div-level-rewards-name" + index}
                                                    >
                                                        Recompensas:
                                                    </div>
                                                    <div
                                                        className="block"
                                                        key={"div-level-rewards-child-1" + index}
                                                    >
                                                        {level.rewards[0]}
                                                    </div>
                                                    <div
                                                        className="block"
                                                        key={"div-level-rewards-child-2" + index}
                                                    >
                                                        {level.rewards[1]}
                                                    </div>
                                                    <div
                                                        className="block"
                                                        key={"div-level-rewards-child-3" + index}
                                                    >
                                                        {level.rewards[2]}
                                                    </div>
                                                </div>
                                            </div>
                                        </Fragment>
                                    ))}
                                </div>
                                <div className="text-grayP">
                                    ¿Cómo sumar puntos y cuántos recibo?
                                </div>
                                <div className="pt-4">
                                    <div className="font-bold">Acciones que tú puedes hacer:</div>
                                    {(levelsConfig?.youActions ?? youActions).map((action, i) => (
                                        <Fragment key={"fragment-level-you-actions" + i}>
                                            <ul
                                                key={"ul-level-you-actions" + i}
                                                className="list-disc pl-4 text-sm"
                                            >
                                                <li key={"li-level-you-actions" + i} className="">
                                                    {action.description}
                                                </li>
                                            </ul>
                                        </Fragment>
                                    ))}
                                </div>
                                <div className="pt-4">
                                    <div className="font-bold">
                                        Puntos por acciones que hacen tus referidos:
                                    </div>
                                    {(levelsConfig?.otherActions ?? otherActions).map(
                                        (action, idx) => (
                                            <Fragment key={"fragment-level-other-actions" + idx}>
                                                <ul
                                                    key={"ul-level-other-actions" + idx}
                                                    className="list-disc pl-4 text-sm"
                                                >
                                                    <li key={"li-level-other-actions" + idx} className="">
                                                        {action.description}
                                                    </li>
                                                </ul>
                                            </Fragment>
                                        )
                                    )}
                                </div>
                                <div className="pt-10">
                                    <div className="max-w-sm">
                                        <button
                                            onClick={handleOpenDisclosure}
                                            type="button"
                                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-lg text-white font-semibold bg-purple transition duration-300 hover:bg-purpleDark focus:outline-none"
                                        >
                                            <div className="flex">
                                                Ver recompensas
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        />
    );
}